export default "__VITE_ASSET__03979f66__"